import _axios1 from "@/plugins/axios1";
import pdfAxios from '@/plugins/pdf_axios'

/**
 * Conference Management
 */
// 获取会议列表
export const getConferenceList = function (data: {
  page: string,
  limit: string,
  code: string,
  name: string,
  abbreviation: string,
  date: any
}) {
  return _axios1.post('/conference/page', data);
};
// 获取会议详情
export const getConferenceDetail = function (id: any) {
  return _axios1.get(`/conference/${id}`);
};
// 新建会议
export const createConference = function (data: any) {
  return _axios1.post('/conference', data);
};
// 更新会议
export const updateConference = function (id: any, data: any) {
  return _axios1.put(`/conference/${id}`, data);
};
// 删除会议
export const deleteConference = function (id: any) {
  return _axios1.delete(`/conference/${id}`);
};

/**
 * Order Import Management
 */
// 获取订单导入列表
export const getOrderImportList = function (data: {
  page: string,
  limit: string,
  code: string,
  conferenceCode: string,
  title: string,
  projectNumber: string,
  groupNumber: string,
  submitter: string,
  authors: string,
  progress: string
}) {
  return _axios1.post('/order/page', data);
};
// 获取订单导入详情
export const getOrderImportDetail = function (id: any) {
  return _axios1.get(`/order/${id}`);
};
// 编辑订单导入（B端）
export const updateOrderImport = function (id: any, data: any) {
  return _axios1.put(`/order/b/teacher/${id}`, data);
};
// 删除订单导入
export const deleteOrderImport = function (id: any) {
  return _axios1.delete(`/order/${id}`);
};
// C端-学生录入订单数据(第一步)
export const submitStudentOrder = function (data: any) {
  return _axios1.post(`/order/c/student`, data);
};
// 获取订单详情
export const getOrderDetail = function (id: any) {
  return _axios1.get(`/order/${id}`);
};
// 更新订单支付状态
export const updateOrderPaymentStatus = function (id: any, data: { paymentStatus: number }) {
  return _axios1.put(`/order/payStatus/${id}`, data);
};
// C端-老师审核学生数据(第二步)
export const teacherReviewStudent = function (id: any, data: any) {
  return _axios1.put(`/order/c/teacherReview/${id}`, data);
};
// 获取订单金额
export const getOrderAmount = function (data: any) {
  return _axios1.post(`/order/c/getOrderAmount`, data);
};
// C端-学生修改订单数据(第三步)
export const updateStudentOrder = function (id: any, data: { sourceUrl: string; paperUrl: string }) {
  return _axios1.put(`/order/c/student/${id}`, data);
};
// 提交支付截图
export const submitPayment = function (id: any, data: { paymentUrl: string; contactInformationName?: string; contactInformationEmail?: string; contactInformationPhone?: string }) {
  return _axios1.put(`/order/pay/${id}`, data);
};
// 导入订单
export const importOrder = function (data: FormData) {
  return _axios1.post(`/order/import/`, data, {
    headers: {
      "Content-Type": "multipart/form-data"
    }
  });
};
// 论文产出--pdf生成
export const getPdf = function (
  data: {
    htmlStr: any;
    marginTop: number;
    marginBottom: number;
  }
) {
  return pdfAxios.post('/pdf/generate/generatePdf', data)
}
// 生成投递涵
export const submitPaper = function (id: any, data: { acceptanceLetterUrl: string; }) {
  return _axios1.put(`/order/acceptanceLetterUrl/${id}`, data);
}
// 下载所有的投递涵
export const getAllLetters = function (id: any) {
  return _axios1.get(`/conference/acceptanceLetterUrls/${id}`);
};

// C端-老师修改订单数据（有数据即可改）
export const updateTeacherOrderC = function (id: any, data: any) {
  return _axios1.put(`/order/c/teacher/${id}`, data);
};